import React, { useState, useEffect, useCallback } from 'react';

import { isEmpty } from 'lodash';
import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import { RadioGroup } from '~/components/Form';

import { t } from '~/helpers';

import DateTime from './componentes/DateTime';

function RelatorioAbastecimentoSeplag() {
  const [open, setOpen] = useState(true);

  const [selecionaranomes, setSelecionaranomes] = useState({});
  const [periodoconsulta, setPeriodoconsulta] = useState('');
  const [pickerDataFim, setPickerDataFim] = useState(null);

  async function getConfigSistema() {
    setPickerDataFim(moment().subtract(1, 'month'));
  }

  const onSerializeData = useCallback(
    (data) => {
      // console.log(data);
      return {
        ...data,
        periodo: periodoconsulta,
      };
    },
    [periodoconsulta, pickerDataFim]
  );

  const handleValidate = useCallback(
    async (data) => {
      try {
        const schema = Yup.object().shape({
          periodo: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')),
        });
        await schema.validate(
          {
            ...data,
            periodo: periodoconsulta,
          },
          {
            abortEarly: false,
          }
        );
      } catch (err) {
        const form = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });
          throw { form };
        }
      }
    },
    [periodoconsulta]
  );

  const handleChangeDatapickerDataFim = React.useCallback((value) => {
    setPickerDataFim(value);
  }, []);

  useEffect(() => {
    if (!isEmpty(pickerDataFim)) {
      const dataselecionada = pickerDataFim.format('MM/YYYY');
      const month = parseInt(dataselecionada.split('/')[0], 10);
      const year = parseInt(dataselecionada.split('/')[1], 10);
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedyear = year.toString().padStart(4, '0');
      const periodo = `${formattedMonth}/${formattedyear}`;
      setPeriodoconsulta(periodo);
    }
  }, [selecionaranomes, pickerDataFim]);

  useEffect(() => {
    getConfigSistema();
  }, []);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Relatório Veículos que Abasteceram"
      relatorio="relabastecimentosseplag"
      serialize={onSerializeData}
      validate={handleValidate}
      initials={{
        tipo: 'xls',
      }}
    >
      <DateTime
        time
        label="Selecione o mês e ano"
        name="selecionaranomes"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
        value={pickerDataFim}
        onChange={handleChangeDatapickerDataFim}
        getValue={(value) => {
          setSelecionaranomes(value);
        }}
        serialize={(value) =>
          value.set({ hour: 0, minute: 0, seconds: 0 }).format('MM/YYYY')
        }
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[{ label: 'Excel', value: 'xls' }]}
      />
    </Report>
  );
}

export default RelatorioAbastecimentoSeplag;
